import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Spinner, useOverlayContext } from 'seagull';
import ContactPicker from '~/components/ContactsPicker/ContactPicker';
import { ManageContactModalForVendor } from '~/components/ManageContactModal';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { useLocaleKeys } from '~/i18n';
import { NewContactModel } from '~/models';
const ContactsSelector = (param)=>{
    let { onChange, error, selectedContactId } = param;
    const { t: texts } = useLocaleKeys('components.contactsSelector');
    const overlayContext = useOverlayContext();
    const { contacts, error: contactsError, isFetching, refresh: fetchContacts } = useContacts({
        refreshOnMount: true
    });
    const selectedContact = contacts === null || contacts === void 0 ? void 0 : contacts.find((c)=>c.id() === selectedContactId);
    useEffect(()=>{
        if (contactsError !== null) {
            overlayContext.showErrorToast(texts.failedToLoadContacts(), 'contacts-error-request-toast');
        }
    }, [
        contactsError
    ]);
    async function openContactModal(props) {
        return overlayContext.showModal({
            biName: 'manage_contact_modal_for_vendor_modal',
            closeOnEscapeKey: false,
            closeOnClickOutside: false,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ManageContactModalForVendor, _object_spread_props(_object_spread({}, props), {
                    testId: "manage-contact-modal",
                    onClose: dismissModal,
                    origin: "Global bill modal"
                }));
            }
        });
    }
    async function newContactPostActions(savedContactData) {
        if (savedContactData) {
            await fetchContacts();
            onChange(savedContactData.id);
        }
    }
    if (isFetching) {
        return /*#__PURE__*/ _jsx(Spinner, {
            centeredInBox: true,
            size: 40,
            centerBoxHeight: 48
        });
    }
    return /*#__PURE__*/ _jsx(ContactPicker, {
        label: texts.label(),
        hideSampleContact: true,
        value: selectedContact !== null && selectedContact !== void 0 ? selectedContact : NewContactModel.makeEmpty(),
        error: error,
        onChange: async (change)=>{
            switch(change.type){
                case 'existingContact':
                    onChange(change.id);
                    break;
                case 'initial':
                    onChange(null);
                    break;
                case 'newContact':
                    {
                        const savedContact = await openContactModal({});
                        await newContactPostActions(savedContact);
                        break;
                    }
                default:
                    break;
            }
        }
    });
};
export default ContactsSelector;
